import { ParamIds, Places } from '../../../Constants'
import BorderoKeys from '../bordero.keys'

export class BorderoFormKeys extends BorderoKeys {
    get place() {
        return Places.borderoForm
    }

    get borderoId() {
        return this._intent.getParameterAsNumber(ParamIds.borderoFormId)
    }

    set borderoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.borderoFormId, value)
    }
}
